import { defineRule } from '../rule.js';

/**
 * W: a monitor or IEM mix feeds no existing wedge/sidefill/IEM and has no stage-box outputs.
 * FOH and FX mixes are exempt.
 */
export const mixWithoutOutput = defineRule(
  'mix-without-output',
  'warning',
  { en: 'Mix without output', de: 'Mix ohne Ausgabe' },
  (data, emit) =>
    Object.values(data.mixes)
      .filter((m) => m.kind === 'monitor' || m.kind === 'iem')
      .filter((m) => !m.outputItemIds.some((id) => data.items[id] !== undefined))
      // stage-box outputs typed in are an output too (U77, exploratory test OIL-150)
      .filter((m) => !(m.outputs ?? []).some((o) => o.trim() !== ''))
      .map((m) => emit([m.id], { number: m.number, name: m.name })),
);
